import { render, staticRenderFns } from "./PrognoseGraph.vue?vue&type=template&id=13668f44"
import script from "./PrognoseGraph.js?vue&type=script&lang=js&external"
export * from "./PrognoseGraph.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports